import React from "react";

interface SectionPriceProps {
  onBookDemo: () => void;
}

const SectionPrice: React.FC<SectionPriceProps> = ({ onBookDemo }) => {
  return (
    <section className="text-black py-8 2xl:py-16 px-4 md:h-[calc(100vh-75px)] 2xl:h-[calc(100vh-96px)]">
      <div className="max-w-4xl 2xl:max-w-5xl mx-auto text-center">
        <h2 className="text-xl 2xl:text-2xl font-semibold mb-6 2xl:mb-12">
          Pricing
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 px-6 md:px-0">
          {/* Solo Starter */}
          <div className="bg-white rounded-xl px-6 py-6 shadow-sm flex flex-col justify-between">
            <div className="flex flex-col flex-1">
              <h3 className="text-lg 2xl:text-xl font-bold mb-2">
                Solo Starter
              </h3>
              <p className="text-xs 2xl:text-sm text-gray-500 mb-4 h-10">
                Reduce operational complexity and streamline reporting
              </p>
              <div className="h-20 md:h-24">
                <div className="text-3xl font-bold mb-1">Free</div>
              </div>
              <ul className="text-left space-y-2 mb-4 flex-1">
                <li className="flex items-start gap-2 text-xs 2xl:text-sm">
                  <span className="text-blue-600">✓</span>
                  Organize your work around
                  <br /> projects and programs
                </li>
                <li className="flex items-start gap-2 text-xs 2xl:text-sm">
                  <span className="text-blue-600">✓</span>
                  Utilize AI assistant to build
                  <br /> knowledge
                </li>
                <li className="flex items-start gap-2 text-xs 2xl:text-sm">
                  <span className="text-blue-600">✓</span>
                  Create your reports based on
                  <br /> custom templates
                </li>
              </ul>
              <p className="text-xs text-gray-500">
                Perfect for first user and to create your organization workspace
              </p>
            </div>
            <a
              //   onClick={() => navigate("/register")}
              href="/register"
              target="_blank"
              className="mt-6 bg-blue-600 text-white text-xs 2xl:text-sm font-semibold py-2 rounded-md hover:bg-blue-700 transition"
            >
              Register
            </a>
          </div>

          {/* Team */}
          <div className="bg-white rounded-xl px-6 py-6 shadow-sm flex flex-col justify-between">
            <div className="flex flex-col flex-1">
              <h3 className="text-lg 2xl:text-xl font-bold mb-2">Team</h3>
              <p className="text-xs 2xl:text-sm text-gray-500 mb-4 h-10">
                Collaborate with your colleagues and stakeholders on your
                workspace
              </p>
              <div className="h-20 md:h-24">
                <div className="text-3xl font-bold mb-1">
                  <p className="mb-1">
                    15 CHF{" "}
                    <span className="text-xs 2xl:text-sm font-normal">
                      /month
                    </span>
                  </p>
                  <p className="text-xs 2xl:text-sm text-gray-500 font-normal">
                    per user
                  </p>
                </div>
              </div>
              <ul className="text-left space-y-2 mb-4 flex-1">
                <li className="flex items-start gap-2 text-xs 2xl:text-sm">
                  <span className="text-blue-600">✓</span>
                  Implement latest technology and AI safely in your organization
                </li>
                <li className="flex items-start gap-2 text-xs 2xl:text-sm">
                  <span className="text-blue-600">✓</span>
                  Add internal and external team members
                </li>
                <li className="flex items-start gap-2 text-xs 2xl:text-sm">
                  <span className="text-blue-600">✓</span>
                  Manage user access and jointly work on tasks
                </li>
              </ul>
              <p className="text-xs text-gray-500">
                Billed annually for every additional user invited to your
                workspace
              </p>
            </div>
            <button
              onClick={onBookDemo}
              className="mt-6 bg-blue-600 text-white text-xs 2xl:text-sm font-semibold py-2 rounded-md hover:bg-blue-700 transition"
            >
              Contact Us
            </button>
          </div>

          {/* Enterprise */}
          <div className="bg-white rounded-xl px-6 py-6 shadow-sm flex flex-col justify-between">
            <div className="flex flex-col flex-1">
              <h3 className="text-lg 2xl:text-xl font-bold mb-2">Enterprise</h3>
              <p className="text-xs 2xl:text-sm text-gray-500 mb-4 h-10">
                For large scale integrations
              </p>
              <div className="h-20 md:h-24">
                <div className="text-3xl font-bold mb-1">Custom</div>
              </div>
              <ul className="text-left space-y-2 mb-4 flex-1">
                <li className="flex items-start gap-2 text-xs 2xl:text-sm">
                  <span className="text-blue-600">✓</span>
                  Individual integration and deployment
                </li>
              </ul>
              <p className="text-xs text-gray-500">&nbsp;</p>
            </div>
            <button
              onClick={onBookDemo}
              className="mt-6 bg-blue-600 text-white text-xs 2xl:text-sm font-semibold py-2 rounded-md hover:bg-blue-700 transition"
            >
              Contact Us
            </button>
          </div>
        </div>

        <div className="mt-6 2xl:mt-12 text-xs max-w-4xl px-6 mx-auto leading-relaxed">
          <p className="mb-6">
            The pricing table above applies exclusively to registered non-profit
            organizations. Customized pricing models are available for private
            entities, including impact funds and similar organizations.
          </p>
          <p>
            At THE ARK, we take data protection and privacy seriously, and follow practices aligned with GDPR and the standards expected of Swiss-based foundations and NGOs.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SectionPrice;
